import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, RotateCcw } from "lucide-react";
import { Button } from "../../components/ui/button";
import { sfx } from "../../lib/sound";

const SCENE = "https://static.prod-images.emergentagent.com/jobs/d586efdf-ef9d-49f8-8917-3ab0a3e986a3/images/5c55b61b10c5324a21cead167f948190dac273fed64dd7af5f4b9b108d4b0a42.png";
const COLORS = ["#ffd700", "#ff4fa3", "#7c5cff", "#3ad1ff", "#5cff8f", "#ff7a3c"];

export default function RumiParty() {
  const navigate = useNavigate();
  const location = useLocation();
  const unlockedNow = location.state?.unlockedNow;
  const cheers = useRef(0);

  useEffect(() => {
    sfx.win();
    const t1 = setTimeout(() => sfx.coin(), 500);
    const t2 = setTimeout(() => sfx.win(), 1400);
    const cheerTimer = setInterval(() => { if (cheers.current++ < 6) sfx.coin(); }, 1700);
    return () => { clearTimeout(t1); clearTimeout(t2); clearInterval(cheerTimer); };
  }, []);

  return (
    <div className="fixed inset-0 overflow-hidden" data-testid="rumi-party" style={{ background: "#0a0518" }}>
      {/* Scène (dansende held op podium) met zachte zoom/wieg */}
      <motion.img src={SCENE} alt="Rumi danst" data-testid="rumi-character"
        className="absolute inset-0 w-full h-full object-cover"
        initial={{ scale: 1.12, opacity: 0 }}
        animate={{ scale: [1.12, 1.18, 1.12], x: [0, -8, 0], opacity: 1 }}
        transition={{ scale: { duration: 3.2, repeat: Infinity, ease: "easeInOut" }, x: { duration: 1.6, repeat: Infinity, ease: "easeInOut" }, opacity: { duration: 0.5 } }} />

      {/* Donkere vignette boven/onder voor leesbaarheid */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(to bottom, rgba(10,5,24,0.65) 0%, transparent 22%, transparent 60%, rgba(10,5,24,0.85) 100%)" }} />

      {/* Extra confetti-laag */}
      {[...Array(50)].map((_, i) => (
        <motion.div key={i} className="absolute rounded-sm pointer-events-none"
          initial={{ y: -60, x: `${Math.random() * 100}vw`, rotate: 0, opacity: 1 }}
          animate={{ y: "110vh", rotate: 720 }}
          transition={{ duration: 2.4 + Math.random() * 2.6, repeat: Infinity, delay: Math.random() * 3, ease: "easeIn" }}
          style={{ width: 8 + Math.random() * 6, height: 12 + Math.random() * 8, background: COLORS[i % COLORS.length] }} />
      ))}

      {/* Titel */}
      <motion.div className="absolute top-0 inset-x-0 z-10 text-center px-6 pt-10"
        initial={{ scale: 0, y: -30 }} animate={{ scale: 1, y: 0 }} transition={{ type: "spring", stiffness: 240, damping: 14 }}>
        <p className="font-heading text-base font-bold tracking-widest" style={{ color: "#ffd700" }}>{unlockedNow ? "100% — NIEUW VRIJGESPEELD!" : "FEESTJE!"}</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black text-white drop-shadow-[0_3px_0_rgba(0,0,0,0.5)]" data-testid="party-title">Rumi danst! 🎉</h1>
      </motion.div>

      {/* Knoppen */}
      <div className="absolute bottom-0 inset-x-0 z-10 flex justify-center gap-3 pb-8 px-6">
        <Button onClick={() => navigate("/leerling/tafeltoets")} className="h-12 rounded-full font-bold border-0 px-6" style={{ background: "#ffd700", color: "#2a1659" }} data-testid="party-again-btn"><RotateCcw className="w-4 h-4 mr-1.5" /> Nog een toets</Button>
        <Button onClick={() => navigate("/leerling")} className="h-12 rounded-full font-bold border-2 bg-transparent px-6 text-white" style={{ borderColor: "#ffffff66" }} data-testid="party-home-btn"><Home className="w-4 h-4 mr-1.5" /> Klaar</Button>
      </div>
    </div>
  );
}
